import { lazy } from 'react';

// 메인화면 역할별 구성 1단계(2026-10-23) - "EXTERNAL" 위젯 코드 -> 기존 컴포넌트.
// 결재/공지는 이미 있던 컴포넌트를 그대로 재사용한다(요구사항: 캘린더/결재함은 기존 컴포넌트
// 재사용). 캘린더(COMMON_SCHEDULE)는 전체화면 토글 상태를 DashboardContainer가 들고 있어야 해서
// 이 레지스트리를 거치지 않고 DashboardContainer에서 직접 특수 처리한다.
export const EXTERNAL_WIDGETS = {
  COMMON_APPROVAL_INBOX: lazy(() => import('../containers/dashboard/approval/DashboardApprovalContainer')),
  COMMON_APPROVAL_SUBMITTED: lazy(() => import('../containers/dashboard/approval/ApprovalSubmittedListContainer')),
  COMMON_NOTICE: lazy(() => import('../components/dashboard/notice/NoticeTemplate')),
};

// COMMON_SCHEDULE은 DashboardContainer가 직접 그린다 - 레이아웃 응답에 있어도 이 목록을
// 돌 때는 건너뛴다.
export const SPECIAL_WIDGETS = ['COMMON_SCHEDULE'];

// 메인화면 재검토(Fable, 2026-10-23) 회귀 1 수정: GET /api/v1/home/layout 호출이 실패해도
// 예전 화면(캘린더/결재 대기함/내 상신/공지)이 완전히 사라지면 안 된다. 서버 세트 판정이 죽어도
// 클라이언트에서 V8 시드의 ROLE=COMMON 레이아웃과 같은 값으로 하드코딩 폴백한다 - 레이아웃
// 테이블의 COMMON 행과 중복 관리가 되지만, 이 폴백이 실제로 쓰이는 건 서버 장애 때뿐이라
// 드리프트 위험보다 "화면이 통째로 빈다"는 회귀가 더 크다.
export const COMMON_FALLBACK_WIDGETS = [
  { widgetCd: 'COMMON_SCHEDULE', widgetNm: '일정', renderTyp: 'EXTERNAL', w: 6, locked: true },
  { widgetCd: 'COMMON_APPROVAL_INBOX', widgetNm: '결재 대기함', renderTyp: 'EXTERNAL', w: 6, locked: true },
  { widgetCd: 'COMMON_APPROVAL_SUBMITTED', widgetNm: '내 상신 진행', renderTyp: 'EXTERNAL', w: 6, locked: true },
  { widgetCd: 'COMMON_NOTICE', widgetNm: '공지사항', renderTyp: 'EXTERNAL', w: 6, locked: false },
];
